/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Injectable } from '@angular/core';
import { ApiEntity } from 'app/api/models/api-entity.model';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { ApiResponseSummary } from 'app/shared/models/api-info.model';
import { DataService } from 'app/shared/services/data.service';
@Injectable({ providedIn: 'root' })
export class EventDetailService extends DataService<any> {
	constructor(apiDependencies: ApiDependenciesService) {
		super(apiDependencies);
	}

	//#region endpoints
	getEventDetailViewEndpoint(itemId: number): string {
		return '/events' + '/' + itemId + '/event-detail';
	}
	createEventFormEndpoint(): string {
		return '/events' + '/';
	}
	updateEventFormEndpoint(itemId: number): string {
		return '/events' + '/' + itemId;
	}
	getEventFormEndpoint(itemId: number): string {
		if (itemId > 0) return '/events' + '/' + itemId;
		return '/events/blank';
	}

	getPublishEventFormEndpoint(itemId: number): string {
		return `/events/${itemId}/publish`;
	}

	//#endregion

	async getEventDetailView(itemId: number): Promise<ApiEntity> {
		let model: ApiEntity;
		await this.setEndpoint(this.getEventDetailViewEndpoint(itemId))
			.getSingle()
			.then((response: any) => {
				model = response;
			});
		return Promise.resolve(model);
	}

	async createEventForm(dataToUpdate: any): Promise<any> {
		return this.saveItem(dataToUpdate, this.createEventFormEndpoint());
	}
	async updateEventForm(itemId: number, dataToUpdate: any): Promise<ApiResponseSummary<any>> {
		return this.updateItem(itemId, dataToUpdate, this.updateEventFormEndpoint(itemId));
	}

	async getEventForm(itemId: number): Promise<ApiEntity> {
		let model: ApiEntity;
		await this.setEndpoint(this.getEventFormEndpoint(itemId))
			.getSingle()
			.then((response: any) => {
				model = response;
			});
		return Promise.resolve(model);
	}

	async getSingleItem(itemId: number, dataToUpdate: any, endpoint: string) {
		console.log(endpoint);
		await this.setEndpoint(endpoint)
			.getSingle()
			.then((response) => {});
	}

	async updateItem(itemId: number, dataToUpdate: any, endpoint: string): Promise<ApiResponseSummary<any>> {
		let result: ApiResponseSummary<any>;

		await this.setEndpoint(endpoint)
			.update(dataToUpdate)
			.then((response) => {
				result = response;
				if (result.success === true) {
				}
			});
		return Promise.resolve(result);
	}

	async saveItem(dataToUpdate: any, endpoint: string): Promise<ApiResponseSummary<any>> {
		let result: ApiResponseSummary<any>;
		await this.setEndpoint(endpoint)
			.save(dataToUpdate)
			.then((response) => {
				result = response;
				if (result.success === true) {
				}
			});
		return Promise.resolve(result);
	}

	async getPublishEventForm(itemId: number): Promise<ApiEntity> {
		let model: ApiEntity;
		await this.setEndpoint(this.getPublishEventFormEndpoint(itemId))
			.getSingle()
			.then((response: any) => {
				model = response;
			});
		return Promise.resolve(model);
	}
	async updateEventStatus(itemId: number, dataToUpdate: any): Promise<ApiResponseSummary<any>> {
		var endpoint = this.updateEventFormEndpoint(itemId) + '/update-status';
		return this.updateItem(itemId, dataToUpdate, endpoint);
	}

	async publishEvent(itemId: number): Promise<ApiResponseSummary<any>> {
		let result: ApiResponseSummary<any>;
		this.blockUI.start('Publishing Event');
		await this.setEndpoint(this.updateEventFormEndpoint(itemId) + '/publish')
			.update({})
			.then((response) => {
				result = response;
				if (result.success === true) {
				}
			})
			.finally(() => {
				this.blockUI.stop();
			});
		return Promise.resolve(result);
	}
	async publishEventPreview(ticketShopDesignId?: number, eventId?: number): Promise<ApiResponseSummary<any>> {
		let result: ApiResponseSummary<any>;
		this.blockUI.start('Publishing Event Preview');
		const endpoint = eventId ? this.updateEventFormEndpoint(eventId) + '/publish-preview' : `/ticket-shop-designs/${ticketShopDesignId}/publish-preview`;
		await this.setEndpoint(endpoint)
			.update({})
			.then((response) => {
				result = response;
				if (result.success === true) {
				}
			})
			.finally(() => {
				this.blockUI.stop();
			});
		return Promise.resolve(result);
	}
}
